export class AppUrl {
  static BASE_URL =  'https://app.crewcamapp.com/api';
  static userEndPoint = `${this.BASE_URL}/user`;
}
export const WebUrl = {
  Privacy: 'https://www.crewcamapp.com/privacypolicy',
  Terms: 'https://www.crewcamapp.com/termsandconditions',
  Support: 'https://www.crewcamapp.com/support',
};
